import { defineStore } from "pinia";
import { ref, computed, reactive, watch } from "vue";
import { useTheme } from "vuetify";
import { connectionStore } from "./ConnectionStore";
import { uiStore } from "./UiStore";
// import { useRouter } from "vue-router";
import { ls } from "@/plugin/secure";
import { useToast, TYPE } from "vue-toastification";
import { useI18n } from "vue-i18n";
import { useRouter, useRoute } from "vue-router";

console.log("==========> start  <==============");
//firebase 분석 호출
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
const firebaseConfig = {
  apiKey: "AIzaSyA8WV3Nn-Zzrnjo-ipohQTN6z1uyi9KbGM",
  authDomain: "miri-serivce.firebaseapp.com",
  projectId: "miri-serivce",
  storageBucket: "miri-serivce.appspot.com",
  messagingSenderId: "17929557552",
  appId: "1:17929557552:web:03fb6948f74bbda51abff5",
  measurementId: "G-F41GJWRYV9"
};
// // Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
console.log("==========> end  <==============");

export const userStore = defineStore("user", () => {
  const currentUser = ref(null);
  const directTargetPath = ref(null);
  const userInfo = ref([]);
  const popupNoticeList = ref([]);
  const router = useRouter();
  const route = useRoute();
  const theme = useTheme();
  const menus = ref([]);
  const { t } = useI18n();
  const i18n = useI18n();
  const portfolio = ref([]);
  const selectedPortfolio = ref([]);
  const useUiStore = uiStore();
  const toast = useToast();
  const useConnectionStore = connectionStore();
  const viewPopupNotice = ref(false);

  const setMenus = (params) => {
    menus.value = params;
  };
  const setUser = async (params) => {
    userInfo.value = params;
  };
  const setPortfolio = (params) => {
    if (params.selected) {
      portfolio.value.selected = params.selected;
      //portfolio 변경
      logEvent(analytics, '포트폴리오선택', {
        content_type: 'image',
        content_id: 'P123477'
      });
    }
    if (params.portfolio) {
      portfolio.value.list = params.portfolio;
    }
  };
  const setPopupNotice = (params) => {
    popupNoticeList.value = params
  };
  const changeLocale = async (params) => {
    userInfo.value.locale = params;

    i18n.locale.value = userInfo.value.locale;
  };
  const getUserData = async () => {
    const { data, code } = await useConnectionStore.request({
      url: "/v2/auth/my",
      method: "post",
      queryparam: {},
    });

    if (code === 200) {
      i18n.locale.value = data.locale;
      data.theme == "light"
        ? (theme.global.name.value = "light")
        : (theme.global.name.value = "dark");

      if (data.phonenumber) {
        data.phonenumber = data.phonenumber.replace(
          /^(.{3})(.*)(.{4})$/,
          "$1-$2-$3"
        );
      }
      await getPortfolioList();
      await setUser({
        ...data,
      });
    }
  };
  const getPortfolioList = async () => {
    const { because, code, data, message, result } =
      await useConnectionStore.request({
        url: "/v2/portfolio/current/list",
        method: "get",
      });
    if (code == 200) {
      if (data.length > 0) {
        const returnPortfolio = {
          selected: data.find((item) => item.defaultYn === "y"),
          portfolio: data.sort((a, b) => {
            if (a.portfolioName === "lobby") return -1;
            if (b.portfolioName === "lobby") return 1;
            return a.portfolioName.localeCompare(b.portfolioName);
          }),
        };

        setPortfolio(returnPortfolio);
      } else {
        toast.warning(t("WARNING_PORTFOLIO_NO_RESULT"));
      }
    } else {
      toast.warning(t("ERROR_PORTFOLIO_API_ERROR"));
    }
  };

  const getPopupNoticeList = async () => {
    const {because, code, data, message, result} = await useConnectionStore.request({
      url : "/v2/board/notice/list_popup",
      method : "get",
    });

    if(code == 200)
    {
      if(data.length > 0) viewPopupNotice.value = true;
      else viewPopupNotice.value = false;
      setPopupNotice(data);
    }
  };

  const logoutUser = async (deleteFg) => {
    let params = {isDelete : false};
    if(deleteFg && deleteFg == true)  params.isDelete = true;
    const { code } = await useConnectionStore.request({
      url: "/v2/auth/signout",
      method: "post",
      queryparam: params,
    });
    if (code == 200) {
      changeLocale("ko_kr");
      userInfo.value = [];
      portfolio.value = [];
      ls.clear();
      if(route.path !== '/setting/deleteUser_Call') router.push("/");
      else router.push("/login_Call");

      userInfo.value = undefined;
      if(deleteFg == true)  toast.success(t("INFO_SUCCESS_DELETE_USER"));
      else {
        logEvent(analytics, '로그아웃', {
          content_type: 'image',
          content_id: 'P123470'
        });
        toast.success(t("SUCCESS_LOGOUT"));
      }
    } else {
      toast.error(t("ERROR_LOGOUT"));
    }
  };

  const setUseLog = async (useCode) => {
    const { code, data, because, result, message } =
      await useConnectionStore.request({
        url: "/v2/miri/portal/setUseData",
        method: "post",
        queryparam: {
          useCode : useCode,
          platform : "WEB",
        },
      });
    if (code == 200)
      console.log("LOG INSERT SUCCESS");
    else
      console.log("LOG INSERT FAIL");
  };

  return {
    currentUser,
    directTargetPath,
    userInfo,
    portfolio,
    menus,
    viewPopupNotice,
    popupNoticeList,
    setMenus,
    changeLocale,
    getPortfolioList,
    setPortfolio,
    setUser,
    getUserData,
    logoutUser,
    getPopupNoticeList,
    setUseLog,
  };
});
